import { useState, useRef, useEffect } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function ClientDropdown({
  value,
  onChange,
  onAddNew,
  options = [],
  error = false,
  helperText = "",
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const wrapperRef = useRef();

  const filteredOptions = options.filter((opt) =>
    opt.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
        setSearchTerm("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="w-full" ref={wrapperRef}>
      {/* Trigger box */}
      <div
        onClick={() => setShowDropdown((prev) => !prev)}
        className={`w-full relative border text-sm px-4 py-2 rounded cursor-pointer ${
          error
            ? "border-[var(--error-color)]"
            : "border-[var(--listdown-color)]  "
        }`}
      >
        <span
          className={
            value ? "text-black" : "text-[var(--listdown-color)] text-base"
          }
        >
          {value || "Select Client"}
        </span>

        <ArrowDropDownIcon
          fontSize="medium"
          className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 pointer-events-none"
        />
      </div>

      {/* Helper text */}
      {error && helperText && (
        <div
          className="text-xs mt-1 ml-1"
          style={{ color: "var(--error-color)" }}
        >
          {helperText}
        </div>
      )}

      {/* Dropdown panel */}
      {showDropdown && (
        <div className="absolute z-50 w-[26%] mt-1 bg-white border border-gray-200 rounded-md shadow-md max-h-64 overflow-y-auto">
          {/* Search inside dropdown */}
          <div className="p-2">
            <input
              autoFocus
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search Clients"
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md outline-none focus:border-blue-500"
            />
          </div>

          {/* Filtered options */}
          {filteredOptions.length > 0 ? (
            filteredOptions.map((item, idx) => (
              <div
                key={idx}
                className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                  item === value ? "bg-blue-50 font-medium" : ""
                }`}
                onClick={() => {
                  onChange(item);
                  setShowDropdown(false);
                  setSearchTerm("");
                }}
              >
                {item}
              </div>
            ))
          ) : (
            <div className="flex flex-col items-center justify-center py-6 text-gray-400 text-sm bg-gray-50">
              <div className="w-12 h-12 bg-white rounded-full shadow flex items-center justify-center mb-2">
                <SearchIcon size={20} />
              </div>
              No Records Found
            </div>
          )}

          {/* Add new client button */}
          <div
            className="flex items-center px-4 py-2 text-sm font-medium text-black bg-gray-100 cursor-pointer  hover:bg-gray-200"
            onClick={() => {
              setShowDropdown(false);
              setSearchTerm("");
              onAddNew();
            }}
          >
            Add New Client <AddCircleIcon fontSize="small" sx={{ ml: 0.5 }} />
          </div>
        </div>
      )}
    </div>
  );
}
